import { getItems } from '../../../services/stockJournal/Item';

export default {
    namespaced: true,
    state: {
        items: [],
    },
    getters: {
        items: state => state.items,
        userItems: (state, getters, rootState) => {
            let userItemsIDs = rootState.stockJournal.userItemsIDs;
            return state.items.filter(each => userItemsIDs.includes(each.id))
        },
    },
    mutations: {
        setItems: (state, payload) => state.items = payload
    },
    actions: {
        fetchItems(context) {
            return new Promise((resolve, reject) => {
                getItems({scope: "all"})
                    .then(response => {
                        context.commit("setItems", response.data);
                        resolve(response);
                    })
                    .catch(error => reject(error));
            });
        },
    }
}